import React, { useEffect, useContext } from 'react'
import { View, Text, TouchableOpacity, Image, StyleSheet, Platform } from 'react-native'
import { ScrollView } from 'react-native-gesture-handler'
import styles from './TermsAndConditionsStyles'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { StatusBar } from 'react-native'
import { info as logInfo, error as logError } from '../../utils/logger'
import { getAlert } from '../appBar/context/AlertsContext'
import { SafeAreaInsetsContext } from 'react-native-safe-area-context'

const TermsAndConditions = ({ termsText, onAccept, closeSearch, version }) => {
    useEffect(() => {
        try {
            logInfo('TTCC', 'modal mounted', { version: String(version ?? '') })
        } catch {}
        return () => {
            try {
                logInfo('TTCC', 'modal unmounted', { version: String(version ?? '') })
            } catch {}
        }
    }, [version])
    const { setAlert } = getAlert()
    const handleClosePress = () => {
        // console.log("closeBottomSheet is of type:", typeof closeBottomSheet);
        try {
            logInfo('TTCC', 'accept click', { version: String(version ?? '') })
        } catch {}
        onAccept(version)
        try {
            setAlert('Términos aceptados', 'white', 'check-circle', 'rgba(32, 201, 151, 0.9)', true, false, 'Feather', 22)
        } catch {}
        closeSearch()
    }

    const { languageFile } = getLanguage()

    // Obtener las primeras tres palabras del texto

    let title = ''

    // Obtener el índice del primer carácter después de las primeras tres palabras
    let startIndex = ''

    // El texto restante después de las primeras tres palabras
    let description = ''

    if (termsText != undefined && termsText.length > 0) {
        title = termsText.split(/\s+/).slice(0, 3).join(' ')

        // Obtener el índice del primer carácter después de las primeras tres palabras
        startIndex = termsText.indexOf(title) + title.length

        // El texto restante después de las primeras tres palabras
        description = termsText.substring(startIndex)
    }

    const insets = useContext?.(SafeAreaInsetsContext) || null
    const bottomSpace = Math.max(Number(insets?.bottom || 0), 16)
    return (
        <View style={{ flex: 1, width: '100%' }}>
            {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ paddingBottom: bottomSpace + 64 }} nestedScrollEnabled={true}>
                <View style={styles.container}>
                    <Image style={styles.image} source={require('../../../assets/termsConditions.png')} />
                    <Text style={styles.title}>{title}</Text>
                    <Text style={styles.description}>{description}</Text>
                </View>
                <View style={styles.spacer}></View>
            </ScrollView>

            <View style={[styles.buttonContainer, { paddingBottom: bottomSpace }]} pointerEvents='box-none'>
                <TouchableOpacity onPress={() => handleClosePress()} style={styles.mainButton}>
                    <Text style={styles.mainButtonText}>{languageFile.accept_ttcc}</Text>
                </TouchableOpacity>
            </View>
        </View>
    )
}

export default TermsAndConditions
